import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonGroup, Box } from '@mui/material';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng); // Save language preference
  };

  const languages = [
    { code: 'sr', label: 'SR' },
    { code: 'sk', label: 'SK' },
    { code: 'de', label: 'DE' },
    { code: 'en', label: 'EN' }
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
      <ButtonGroup size="small" aria-label="language switcher">
        {languages.map((lang) => (
          <Button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            variant={i18n.language === lang.code ? 'contained' : 'outlined'}
            sx={{ minWidth: '40px' }}
          >
            {lang.label}
          </Button>
        ))}
      </ButtonGroup>
    </Box>
  );
};

export default LanguageSwitcher; 